import { AfterViewInit, Directive, ElementRef, HostBinding, OnDestroy } from '@angular/core';
import { Subject, combineLatest, filter, fromEvent, startWith, takeUntil } from 'rxjs';
import { FormControlService } from '../form-control.service';

@Directive({
  selector: '[ssFormInput]'
})
export class FormInputDirective implements OnDestroy, AfterViewInit {

  private readonly _destroy = new Subject<void>();

  readonly readOnlyObs = this._formControlService?.readOnlyObs;
  readonly focusedSubject = this._formControlService?.focusedSubject;

  @HostBinding('readonly')
  readonly: boolean = false

  constructor(
    private _elementRef: ElementRef<HTMLInputElement | HTMLTextAreaElement>,
    private _formControlService: FormControlService,
  ) {

    this.readOnlyObs.subscribe((readOnly) => this.readonly = readOnly)
  }

  ngAfterViewInit(): void {

    const focusObs = fromEvent(this._elementRef.nativeElement, 'focus')

    combineLatest([
      this.readOnlyObs.pipe(startWith(false)),
      focusObs
    ])
      .pipe(
        filter(([readOnly]) => !readOnly),
        takeUntil(this._destroy)
      )
      .subscribe(([readOnly]) => {
        this._elementRef.nativeElement.select();
        this.focusedSubject.next(true)
      })

    const focusOutObs = fromEvent(this._elementRef.nativeElement, 'focusout')

    focusOutObs.pipe(takeUntil(this._destroy))
      .subscribe(() => {
        this._formControlService.focusedSubject.next(false)
        this._formControlService.touchedSubject.next(true)
      })

  }


  ngOnDestroy(): void {
    this._destroy.next();
    this._destroy.complete();
  }

}
